import graph from './graph2'

export const fetchGraph2 =
  (req, data, eid, ctx = {}) =>
  async _ => {
    const res = await graph(req, data, eid, ctx)
    return res
  }
